import * as actions from 'actions';

const INITIAL_STATE = 'recent';

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case actions.COMMENTS_CHANGE_SORT:
      return action.value;

    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/members/state/comments/sort/reducer.js
 **/